import Summarize2ndGrader from "./templates/Summarize2ndGrader";
import General from "./templates/General";
import RestaurantReview from "./templates/RestaurantReview";
import ProductNameGenerator from "./templates/ProductNameGenerator";
import NotesToSummary from "./templates/NotesToSummary";
import AirportCodeExtractor from "./templates/AirportCodeExtractor";
import EssayOutline from "./templates/EssayOutline";
import FactualAnswering from "./templates/FactualAnswering";
import MovieToEmoji from "./templates/MovieToEmoji";

const TemplatesConfig = [{
    id: 'general',
    name: 'General',
    component: General
}, {
    id: 'airport_code_extractor',
    name: 'Airport Code Extractor',
    component: AirportCodeExtractor
}, {
    id: 'essay_outline',
    name: 'Essay Outline',
    component: EssayOutline
}, {
    id: 'factual_answering',
    name: 'Factual Answering',
    component: FactualAnswering
}, {
    id: 'movie_to_emoji',
    name: 'Movie To Emoji',
    component: MovieToEmoji
}, {
    id: 'notes_to_summary',
    name: 'Notes To Summary',
    component: NotesToSummary
}, {
    id: 'product_name_generator',
    name: 'Product Name Generator',
    component: ProductNameGenerator
}, {
    id: 'restaurant_review_creator',
    name: 'Restaurant Review Creator',
    component: RestaurantReview
}, {
    id: 'summarize_2nd_grader',
    name: 'Summarize For A 2nd Grader',
    component: Summarize2ndGrader
}];

export default TemplatesConfig;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/TextCompletion/TemplatesConfig.tsx